import { create } from 'zustand';
import { useOperatorStore } from './useOperatorStore';
import db from '../../db';

// Load initial state from IndexedDB
const initializeAuthStore = async (set) => {
  const tokenRecord = await db.auth.get('authToken');
  const userRecord = await db.auth.get('authUser');

  const user = userRecord ? JSON.parse(userRecord.value) : null;

  set({
    token: tokenRecord?.value || '',
    user,
    isAuthenticated: !!tokenRecord?.value,
    isAuthLoaded: true,
  });

  // If user is OPERATOR or LOCATION_OWNER, set operatorId from user
  if ((user?.role === 'OPERATOR' || user?.role === 'LOCATION_OWNER') && user?.operatorId) {
    useOperatorStore.getState().setOperatorID(user.operatorId);
  } else {
    // For SUPER_ADMIN/ADMIN etc., restore last selected operator from IndexedDB
    useOperatorStore.getState().rehydrate();
  }
};

export const useAuthStore = create((set) => {
  set({ isAuthLoaded: false }); // NEW: Add loading state
  initializeAuthStore(set); // Load auth state asynchronously

  return {
    token: '',
    user: null,
    isAuthenticated: false,
    isAuthLoaded: false, // NEW: Tracks if auth is initialized

    setCredentials: async (newToken, user) => {
      await db.auth.put({ key: 'authToken', value: newToken });
      await db.auth.put({ key: 'authUser', value: JSON.stringify(user) });

      set({ token: newToken, user, isAuthenticated: true, isAuthLoaded: true });

      // If user is OPERATOR, set operatorId
      if (
        (user?.role === 'OPERATOR' || user?.role === 'LOCATION_OWNER') &&
        user?.operatorId
      ) {
        useOperatorStore.getState().setOperatorID(user.operatorId);
      }
    },

    clearAuth: async () => {
      await db.auth.clear();
      set({
        token: '',
        user: null,
        isAuthenticated: false,
        isAuthLoaded: true,
      });
      useOperatorStore.getState().clearOperatorID();
    },
  };
});
